export function isAcknowledgedStore(store) {
    const s = store;
    return typeof s.getShared === 'function' && typeof s.setShared === 'function';
}
/** An in-memory `SecureStore` for tests and the offline-first boot path. Not for production secrets. */
export class InMemorySecureStore {
    map = new Map();
    getShared(key) {
        return Promise.resolve({ ok: true, value: this.map.get(key) });
    }
    setShared(key, value) {
        this.map.set(key, value);
        return Promise.resolve(true);
    }
    get(key) {
        return Promise.resolve(this.map.get(key));
    }
    set(key, value) {
        this.map.set(key, value);
        return Promise.resolve();
    }
    remove(key) {
        this.map.delete(key);
        return Promise.resolve();
    }
}
//# sourceMappingURL=secure-store.js.map